// Cumulative spend across every saved session, plus what the session currently
// running has cost so far. The Realtime API bills per audio minute and the whole
// conversation is re-sent on every turn, so the running figure climbs faster the
// longer a session goes — worth having on screen rather than on a monthly bill.

function usd(n) {
  const v = Number(n) || 0;
  // Sub-cent sessions are normal on the mini tier; rounding them to $0.00 would
  // make the meter look broken.
  if (v > 0 && v < 0.01) return '<$0.01';
  return `$${v.toFixed(2)}`;
}

export default function SpendMeter({ spend, liveCost, active, onOpenHistory }) {
  const total = spend?.total_usd || 0;
  const sessions = spend?.sessions || 0;
  const minutes = spend?.minutes || 0;
  const today = spend?.by_day?.[0];

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/40 px-4 py-3 text-xs">
      <div className="flex items-baseline justify-between">
        <span className="font-semibold uppercase tracking-wider text-slate-400">
          Spend
        </span>
        <span className="tabular-nums text-slate-300">{usd(total)}</span>
      </div>

      <div className="mt-1 space-y-0.5 text-[11px] text-slate-500">
        <div className="flex justify-between">
          <span>{sessions} session{sessions === 1 ? '' : 's'}</span>
          <span className="tabular-nums">{minutes.toFixed(0)} min</span>
        </div>
        {today && (
          <div className="flex justify-between">
            <span>today</span>
            <span className="tabular-nums">{usd(today.usd)}</span>
          </div>
        )}
        {active && (
          <div className="flex justify-between text-emerald-400">
            <span>this session</span>
            <span className="tabular-nums">
              {liveCost == null ? 'counting…' : usd(liveCost)}
            </span>
          </div>
        )}
      </div>

      <button
        type="button"
        onClick={onOpenHistory}
        className="mt-2 w-full rounded-lg border border-slate-800 py-1 text-[11px] text-slate-400 hover:bg-slate-800 hover:text-slate-200"
      >
        View past sessions
      </button>

      {spend?.model && (
        <div className="mt-1.5 truncate text-[10px] text-slate-600" title={spend.model}>
          {spend.model}
        </div>
      )}
    </div>
  );
}
